module.exports = "/_next/static/images/ConsistentData-6079b5279a74b9aca03bc927ed3dbd09.webp";